import { render, staticRenderFns } from "./CakeProductChoice.vue?vue&type=template&id=1659d27f&"
import script from "./CakeProductChoice.vue?vue&type=script&lang=js&"
export * from "./CakeProductChoice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports